const hasExclusiveValue = field =>
  Object.prototype.hasOwnProperty.call(field?.inputtable || {}, "sExclusiveValue");

export const getExclusiveValueConfig = (fields = [], fieldName) => {
  const field = fields.find(
    candidate =>
      candidate?.component?.sName === fieldName && hasExclusiveValue(candidate)
  );

  if (!field) return null;

  return {
    fieldName,
    exclusiveValue: field.inputtable.sExclusiveValue,
    replacementValue:
      field.inputtable.sExclusiveReplacementValue ??
      field.component?.sUncheckedValue ??
      field.component?.sDefaultValue ??
      ""
  };
};

export const applyExclusiveValue = (
  rows = [],
  fields = [],
  rowId,
  fieldName,
  value
) => {
  const config = getExclusiveValueConfig(fields, fieldName);

  return rows.map(row => {
    if (row.id === rowId) {
      return { ...row, [fieldName]: value };
    }

    if (config && value === config.exclusiveValue && row[fieldName] === value) {
      return { ...row, [fieldName]: config.replacementValue };
    }

    return row;
  });
};

export const getExclusiveValueErrors = (rows = [], fields = []) =>
  fields.flatMap(field => {
    const fieldName = field?.component?.sName;
    const config = getExclusiveValueConfig(fields, fieldName);

    if (!config) return [];

    const matchingRows = rows.filter(
      row => row?.[fieldName] === config.exclusiveValue
    );

    if (matchingRows.length <= 1) return [];

    return matchingRows.map(row => ({
      id: row.id,
      fieldName,
      helperText: `${field?.inputtable?.sHeader || fieldName} can only contain one ${String(config.exclusiveValue)} value`
    }));
  });
